import React from "react";

// Recreates the business card lockup: KOEHN (struck-through) / HEADLIGHT (blue) / RESTORATION (white)
export const LogoLockup = ({ size = "md", className = "", showEyebrow = true, align = "left" }) => {
  const sizes = {
    sm: { eyebrow: "text-[8px]", koehn: "text-xl", sub: "text-lg" },
    md: { eyebrow: "text-[9px] sm:text-[10px]", koehn: "text-2xl sm:text-3xl", sub: "text-lg sm:text-xl" },
    lg: { eyebrow: "text-xs sm:text-sm", koehn: "text-4xl sm:text-5xl", sub: "text-2xl sm:text-3xl" },
  };
  const s = sizes[size] || sizes.md;
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";

  return (
    <div className={`flex flex-col ${alignCls} leading-none ${className}`}>
      {showEyebrow && (
        <span className={`font-sans ${s.eyebrow} text-white/55 tracking-[0.24em] uppercase mb-1`}>
          Headlight Restoration
        </span>
      )}
      <span className={`font-display ${s.koehn} text-white tracking-[0.06em] relative inline-block`}>
        KOEHN
        <span className="absolute left-0 right-0 top-1/2 h-[2px] bg-white/80" aria-hidden="true" />
      </span>
      <span className={`font-display ${s.sub} text-[#3B9BE8] tracking-[0.08em] mt-1`}>HEADLIGHT</span>
      <span className={`font-display ${s.sub} text-white tracking-[0.08em]`}>RESTORATION</span>
    </div>
  );
};
